import { HttpRequest } from './HttpRequest'

export const Version = async () => {
    try {
        const response = await HttpRequest().get("/version")
            return response.data
    }  catch (error) {
        throw new Error('API ERROR') 
    }
}
